import React, { useState, useRef, useEffect } from "react";
import {
  ButtonDone,
  ColContent,
  Content,
  ContentAnswer,
  ContentComments,
  ContentForm,
  ContentProfile,
  ContentUpdateButton,
  GeneralContainer,
  ImgProfile,
  RowForm,
  FileUpload,
  ContentAttachment,
  CardContainer,
  ContentImgCard,
  ImgAttach,
  ContentTextCard,
  DownloadLink,
  TitleCard,
} from "./MyCaseDetailComponent.styled";
import { Box, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel/TabPanel";
import { TextField, IconButton } from "@material-ui/core";
import { theme as themeConfig } from "../../themes/themes";
import imageProfileComments from "../../assets/svg/img-profile.svg";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CommentsCases from "../CommentsCases/CommentsCases";
import imgAttachedFile from "../../assets/svg/img-attached-file.svg";
import { base64ToArrayBuffer } from "../../helpers/base64ToArrayBuffer";
import { getExtension } from "../../helpers/getExtension";
import { toBase64 } from "../../helpers/toBase64";
import { toCamelCaseFirstLetter } from "../../util/UtilityFunctions";
import ModalLoader from "../ModalLoader/ModalLoader";

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    fontSize: "14px",
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};

const MyCaseDetailComponent = (props) => {
  const [valueTab, setValueTab] = useState(0);
  const rMarket = useRef();
  const rTimeUnit = useRef();
  const rSubPolicies = useRef();
  const [myListMarkets] = useState([
    {
      value: 1,
      label: "Market One",
    },
    {
      value: 2,
      label: "Market Two",
    },
  ]);
  const [myListTimeUnits] = useState([
    { value: "Seconds", label: "Seconds" },
    { value: "Minutes", label: "Minutes" },
    { value: "Hours", label: "Hours" },
    { value: "Days", label: "Days" },
  ]);
  const [attachedFile, setAttachedFile] = useState();
  const rUploadFile = useRef();

  const handleFileUpload = async (idFormAdditionalDataQuestion) => {
    let file = rUploadFile?.current?.files[0];
    let base64Content = await toBase64(file);
    base64Content = base64Content.split("base64,")[1];

    props.additionalData.fileAttached = file;
    props.additionalData.fileAttachedBase64 = base64Content;
    props.additionalData.fileAttachedIdDataQuestion =
      idFormAdditionalDataQuestion;
    setAttachedFile(file);
  };

  const handleUpload = () => {
    rUploadFile.current.value = "";
    rUploadFile.current.click();
  };

  /*   const handleChangePolicies = (event, idFormAdditionalDataQuestion) => {
    props.additionalData.policyCaseAdditonalDataPolicies = event;
    props.additionalData.policiesIdDataQuestion = idFormAdditionalDataQuestion;
  }; */

  const handleChangePolicy = (event, idFormAdditionalDataQuestion) => {
    props.additionalData.policyCaseAdditonalDataPolicies = event;
    props.additionalData.policiesIdDataQuestion = idFormAdditionalDataQuestion;
    props.handleChangeMainPolicy(event);
    rSubPolicies.current.state.selectValue = [];
  };

  const handleChangeSubPolicies = (event, idFormAdditionalDataQuestion) => {
    props.additionalData.policyCaseAdditonalDataSubPolicies = event;
    if (props.additionalDataPreview) {
      props.additionalDataPreview.map((item) => {
        if (item.title === "Sub-Policies") {
          idFormAdditionalDataQuestion = item.idFormAdditionalDataQuestion;
        }
      });
      props.additionalData.subPoliciesIdDataQuestion =
        idFormAdditionalDataQuestion;
    }
  };

  const handleChangeQueues = (event, idFormAdditionalDataQuestion) => {
    props.additionalData.policyCaseAdditonalDataQueues = event;
    props.additionalData.queuesIdDataQuestion = idFormAdditionalDataQuestion;
  };

  const handleChangeMarkets = (event) => {
    props.additionalData.marketsValue = event;
  };

  const handleChangeTimeUnits = (event, idFormAdditionalDataQuestion) => {
    props.additionalData.timeUnit = event;
    props.additionalData.timeUnitIdDataQuestion = idFormAdditionalDataQuestion;
  };

  const handleChangeInsightsPoc = (event, idFormAdditionalDataQuestion) => {
    props.additionalData.policyCaseAdditonalDataInsightPocs = event;
    props.additionalData.insightPocsIdDataQuestion =
      idFormAdditionalDataQuestion;
  };

  const handleChangeTabValue = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleDownloadAttachment = (fileBase64, fileName) => {
    let arrBuffer = base64ToArrayBuffer(fileBase64);
    let ext = getExtension(fileName);
    let newBlob = new Blob([arrBuffer], {
      type: ext.toLowerCase() === "pdf" ? "application/pdf" : "image/png",
    });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(newBlob);
    link.download = `${fileName}`;
    link.click();
  };

  let handleChangeInput = (event, item) => {
    if (item && event.target.value) {
      props.setCommentData({
        idCase: props.idCase,
        comment: event.target.value,
      });
    }
  };

  let handleChangeInputEdit = (event, item) => {
    if (item && event.target.value) {
      props.setCommentData({
        idCase: item.idCase,
        idCaseComment: item.idCaseComment,
        comment: event.target.value,
      });
    }
  };

  let attachFile = (mandatory) => {
    if (attachedFile) {
      if (attachedFile.name) {
        return attachedFile.name;
      } else {
        return (
          <DownloadLink
            onClick={() =>
              handleDownloadAttachment(
                props?.beforeAdditionalData?.base64FileContent,
                props?.beforeAdditionalData?.fileAttached
              )
            }
          >
            {attachedFile}
          </DownloadLink>
        );
      }
    } else {
      return (
        <>
          {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}Attach
          additional files / Benefit quantification
        </>
      );
    }
  };

  useEffect(() => {
    if (props.beforeAdditionalData) {
      if (Array.isArray(props.beforeAdditionalData)) {
        props.beforeAdditionalData.map((element) => {
          if (
            element.idAdditionalDataQuestionNavigation.title ===
            "Impacted Policies"
          ) {
            let policies = JSON.parse(element.additionalDataAnswer);
            props.additionalData.policyCaseAdditonalDataPolicies.push(policies);
            props.additionalData.policiesIdDataQuestion =
              element.idAdditionalDataQuestion;
          } else if (
            element.idAdditionalDataQuestionNavigation.title === "Sub-Policies"
          ) {
            let subPolicies = JSON.parse(element.additionalDataAnswer);
            props.additionalData.policyCaseAdditonalDataSubPolicies.push(
              subPolicies
            );
            props.additionalData.subPoliciesIdDataQuestion =
              element.idAdditionalDataQuestion;
          } else if (
            element.idAdditionalDataQuestionNavigation.title ===
            "Impacted Queues"
          ) {
            let queues = JSON.parse(element.additionalDataAnswer);
            props.additionalData.policyCaseAdditonalDataQueues.push(queues);
            props.additionalData.queuesIdDataQuestion =
              element.idAdditionalDataQuestion;
          } else if (
            element.idAdditionalDataQuestionNavigation.title === "Insights POC"
          ) {
            let insightPocs = JSON.parse(element.additionalDataAnswer);
            props.additionalData.policyCaseAdditonalDataInsightPocs = [
              insightPocs,
            ];
            props.additionalData.insightPocsIdDataQuestion =
              element.idAdditionalDataQuestion;
          } else if (
            element.idAdditionalDataQuestionNavigation.title === "Time Unit"
          ) {
            props.additionalData.timeUnit = element.additionalDataAnswer;
            props.additionalData.timeUnitIdDataQuestionm =
              element.idAdditionalDataQuestion;
          } else if (
            element.idAdditionalDataQuestionNavigation.title ===
            "Primary Benefit"
          ) {
            props.additionalData.benefitEuros = element.additionalDataAnswer;
            props.additionalData.benefitEurosIdDataQuestion =
              element.idAdditionalDataQuestion;
          } else if (
            element.idAdditionalDataQuestionNavigation.title ===
            "Secondary Benefit"
          ) {
            props.additionalData.otherBenefit1 = element.additionalDataAnswer;
            props.additionalData.otherBenefit1IdDataQuestion =
              element.idAdditionalDataQuestion;
          } else if (element.idAdditionalDataQuestion === 38) {
            props.additionalData.fileAttached = element.additionalDataAnswer;
            props.additionalData.fileAttachedIdDataQuestion =
              element.idAdditionalDataQuestion;
            setAttachedFile(element.additionalDataAnswer);
          } else {
            props.additionalData.otherBenefit2 = element.additionalDataAnswer;
            props.additionalData.otherBenefit2IdDataQuestion =
              element.idAdditionalDataQuestion;
          }
        });
      }
    }
  }, [props.beforeAdditionalData]);

  let renderForm = () => {
    return (
      <RowForm>
        <ColContent>
          <ContentProfile>
            <ImgProfile src={imageProfileComments} alt="" />
          </ContentProfile>
        </ColContent>
        <ColContent>
          <TextField
            id="comment-description"
            variant="standard"
            placeholder="Type your comment"
            onChange={(e) => handleChangeInput(e, props.idCase)}
          />
        </ColContent>
        <ColContent>
          <IconButton
            onClick={() => props.handleCreateComment(props.commentData)}
          >
            <ArrowCircleUpIcon />
          </IconButton>
        </ColContent>
      </RowForm>
    );
  };

  let renderAdditionalDataPreview = (
    item,
    mandatory,
    questionType,
    idFormAdditionalDataQuestion
  ) => {
    switch (questionType) {
      case "File":
        return (
          <>
            <Col md={8} className="mt-2">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {attachFile(mandatory)}
              </Form.Label>
            </Col>
            <Col md={4}>
              <IconButton onClick={() => handleUpload()}>
                <AddCircleOutlineIcon />
                <FileUpload
                  ref={rUploadFile}
                  type="file"
                  accept=".jpg,.png,.jpeg,application/pdf"
                  onChange={() =>
                    handleFileUpload(idFormAdditionalDataQuestion)
                  }
                />
              </IconButton>
            </Col>
          </>
        );
      case "FreeText":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}
                {item}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="text"
                style={{ fontSize: "14px" }}
                defaultValue={props.additionalData.otherBenefit2}
                onChange={(e) => {
                  props.additionalData.otherBenefit2 = e.target.value;
                  props.additionalData.otherBenefit2IdDataQuestion =
                    idFormAdditionalDataQuestion;
                }}
                placeholder=""
                required={mandatory}
              />
            </Col>
          </>
        );

      case "List":
        return renderAddionalData(
          item,
          mandatory,
          idFormAdditionalDataQuestion
        );

      default:
        break;
    }
  };

  let renderAddionalData = (item, mandatory, idFormAdditionalDataQuestion) => {
    switch (item) {
      case "Primary Benefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}
                Primary Benefit
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={props?.additionalData?.benefitEuros}
                onChange={(e) => {
                  props.additionalData.benefitEuros = e.target.value;
                  props.additionalData.benefitEurosIdDataQuestion =
                    idFormAdditionalDataQuestion;
                }}
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );
      case "Secondary Benefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}
                Secondary Benefit
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={props?.additionalData?.otherBenefit1}
                onChange={(e) => {
                  props.additionalData.otherBenefit1 = e.target.value;
                  props.additionalData.otherBenefit1IdDataQuestion =
                    idFormAdditionalDataQuestion;
                }}
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );

      case "ThirdBenefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}Other
                benefit2
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={props?.additionalData?.otherBenefit2}
                onChange={(e) =>
                  (props.additionalData.otherBenefit2 = e.target.value)
                }
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );

      case "FourBenefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}Other
                benefit3
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={props?.beforeAdditionalData?.otherBenefit3}
                onChange={(e) =>
                  (props.additionalData.otherBenefit3 = e.target.value)
                }
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );

      case "FiveBenefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}Other
                benefit4
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={props?.beforeAdditionalData?.otherBenefit4}
                onChange={(e) =>
                  (props.additionalData.otherBenefit4 = e.target.value)
                }
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );

      case "SixBenefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}Other
                benefit5
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={props?.beforeAdditionalData?.otherBenefit5}
                onChange={(e) =>
                  (props.additionalData.otherBenefit5 = e.target.value)
                }
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );

      case "Impacted Policies":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}
                impacted policy/policies
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of policies applicable for the maket..."
                defaultValue={
                  Array.isArray(
                    props?.additionalData?.policyCaseAdditonalDataPolicies
                  ) &&
                  props?.additionalData?.policyCaseAdditonalDataPolicies.map(
                    (item) => {
                      return { value: item.value, label: item.label };
                    }
                  )
                }
                options={props.myListPolicies}
                onChange={(e) =>
                  handleChangePolicy(e, idFormAdditionalDataQuestion)
                }
                isMandatory={mandatory}
              />
            </Col>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}
                Sub Policies
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of Sub Policies"
                defaultValue={
                  Array.isArray(
                    props?.additionalData?.policyCaseAdditonalDataSubPolicies
                  ) &&
                  props?.additionalData?.policyCaseAdditonalDataSubPolicies.map(
                    (item) => {
                      return { value: item.value, label: item.label };
                    }
                  )
                }
                options={props.mySubPolicies}
                onChange={(e) =>
                  handleChangeSubPolicies(e, idFormAdditionalDataQuestion)
                }
                isMulti
                isMandatory={mandatory}
                ref={rSubPolicies}
              />
            </Col>
          </>
        );

      case "Impacted Queues":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.primary.redLight }}>*</span>}
                impacted queue/queues
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of queues applicable for the maket..."
                defaultValue={
                  Array.isArray(
                    props?.additionalData?.policyCaseAdditonalDataQueues
                  ) &&
                  props?.additionalData?.policyCaseAdditonalDataQueues.map(
                    (item) => {
                      return { value: item.value, label: item.label };
                    }
                  )
                }
                options={props.myListQueues}
                onChange={(e) =>
                  handleChangeQueues(e, idFormAdditionalDataQuestion)
                }
                isMulti
                isMandatory={mandatory ? true : false}
              />
            </Col>
          </>
        );
      case "Applicable Market":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
                Applicable market(s)
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of markets in the site"
                ref={rMarket}
                options={myListMarkets}
                onChange={handleChangeMarkets}
                isMandatory={mandatory}
                isMulti
              />
            </Col>
          </>
        );

      case "Time Unit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}Time
                Unit
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="Select"
                ref={rTimeUnit}
                options={myListTimeUnits}
                defaultValue={{
                  value: toCamelCaseFirstLetter(
                    props?.additionalData?.timeUnit
                  ),
                  label: toCamelCaseFirstLetter(
                    props?.additionalData?.timeUnit
                  ),
                }}
                onChange={(e) =>
                  handleChangeTimeUnits(e, idFormAdditionalDataQuestion)
                }
                isMandatory={mandatory}
              />
            </Col>
          </>
        );

      case "Insights POC":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}Add
                insights POC
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="Select"
                defaultValue={
                  Array.isArray(
                    props?.additionalData?.policyCaseAdditonalDataInsightPocs
                  ) &&
                  props?.additionalData?.policyCaseAdditonalDataInsightPocs?.map(
                    (item) => {
                      return {
                        value: item.value,
                        label: item.label,
                      };
                    }
                  )
                }
                options={props.myListInsightsPoc}
                onChange={(e) =>
                  handleChangeInsightsPoc(e, idFormAdditionalDataQuestion)
                }
                isMandatory={mandatory}
              />
            </Col>
          </>
        );

      case "Impacted Volume":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
                Impacted Volume %
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="text"
                style={{ fontSize: "14px" }}
                defaultValue={
                  props?.beforeAdditionalData?.impactedVolumePercentage
                }
                onChange={(e) =>
                (props.additionalData.impactedVolumePercentage =
                  e.target.value)
                }
                required={mandatory}
                placeholder="85%"
              />
            </Col>
          </>
        );
      case "Impacted Time":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
                Impacted time per transaction
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={
                  props?.beforeAdditionalData?.impactedTimePerTransaction
                }
                onChange={(e) =>
                (props.additionalData.impactedTimePerTransaction =
                  e.target.value)
                }
                required={mandatory}
                placeholder="6358"
              />
            </Col>
          </>
        );
      case "Error Percentage Last Month":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}%
                errors due to this policy in the last one month
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                defaultValue={
                  props?.beforeAdditionalData?.errorPercentageInTheLastMonth
                }
                onChange={(e) =>
                (props.additionalData.errorPercentageInTheLastMonth =
                  e.target.value)
                }
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );
      case "Error Percentage Calculation":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}Error
                % calculation
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="text"
                style={{ fontSize: "14px" }}
                defaultValue={
                  props?.beforeAdditionalData?.errorPercentageCalculation
                }
                onChange={(e) =>
                (props.additionalData.errorPercentageCalculation =
                  e.target.value)
                }
                placeholder="Free text"
                required={mandatory}
              />
            </Col>
          </>
        );

      default:
        break;
    }
  };

  let renderComments = () => {
    return (
      props.comments?.length > 0 &&
      props.comments.map((item, index) => {
        return (
          <CommentsCases
            key={index}
            item={item}
            handleUpdateComment={props.handleUpdateComment}
            handleChangeInputEdit={handleChangeInputEdit}
            isEditComment={props.isEditComment}
            handleEditComment={props.handleEditComment}
            handleDeleteComment={props.handleDeleteComment}
            handleCancelUpdateComment={props.handleCancelUpdateComment}
            commentData={props.commentData}
          />
        );
      })
    );
  };

  return (
    <>
      {props?.loadingQueryCaseById && <ModalLoader />}
      {!props?.loadingQueryCaseById &&
        props.policyQuestionAnswers?.map(
          (item, index) =>
            item?.base64FileContent && (
              <ContentAttachment key={index}>
                <CardContainer
                  onClick={() =>
                    handleDownloadAttachment(
                      item?.base64FileContent,
                      item?.answer
                    )
                  }
                >
                  <ContentImgCard>
                    <ImgAttach src={imgAttachedFile} />
                  </ContentImgCard>
                  <ContentTextCard>
                    <TitleCard>{item?.answer}</TitleCard>
                    {/* <FileSizeText>27 KB</FileSizeText>{" "} */}
                    <DownloadLink>Download</DownloadLink>
                  </ContentTextCard>
                </CardContainer>
              </ContentAttachment>
            )
        )}
      {!props?.loadingQueryCaseById && (
        <GeneralContainer>
          <ContentForm>
            {props.policyQuestionAnswers?.map(
              (item, index) =>
                !item?.base64FileContent && (
                  <ContentAnswer key={index}>
                    <p>
                      {++index +
                        " " +
                        item.idQuestionFormNavigation.questionTitle}{" "}
                    </p>
                    <p>{item.answer}</p>
                  </ContentAnswer>
                )
            )}
          </ContentForm>
          <ContentComments>
            <Content>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  indicatorColor="secondary"
                  value={valueTab}
                  onChange={handleChangeTabValue}
                  aria-label="comments-tabs"
                >
                  <Tab
                    style={{
                      textTransform: "capitalize",
                      color: valueTab === 0 ? themeConfig.text.primary : "",
                      width: "13em",
                    }}
                    label="Comments"
                    {...a11yProps(0)}
                  />
                  <Tab
                    style={{
                      textTransform: "capitalize",
                      color: valueTab === 1 ? themeConfig.text.primary : "",
                      width: "13em",
                    }}
                    label="Additional Data"
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Box>
              <TabPanel value={valueTab} index={0}>
                <p>
                  {props.permissions
                    ?.map((item) => item.actionName)
                    .indexOf("AddComment") !== -1 && renderForm()}
                </p>
                <p>{renderComments()}</p>
                <ContentUpdateButton>
                  <ButtonDone
                    hidden={
                      props.permissions
                        .map((item) => item.actionName)
                        .indexOf("AddComment") !== -1
                        ? false
                        : true
                    }
                    disabled={props.commentData ? false : true}
                    onClick={() => props.handleSendChanges(props.commentData)}
                  >
                    Send Changes
                  </ButtonDone>
                </ContentUpdateButton>
              </TabPanel>
              <TabPanel value={valueTab} index={1}>
                <Row
                  className="my-3"
                  style={{
                    overflowY: "scroll",
                    height: "fit-content",
                    maxHeight: "592.5px",
                  }}
                >
                  <Col md="12">
                    <p
                      style={{
                        color: themeConfig.neutral.gray[2600],
                        fontSize: "13px",
                        textAlign: "right",
                      }}
                    >
                      <span style={{ color: themeConfig.status.error }}>*</span> Field
                      Mandatory
                    </p>
                  </Col>
                  {props.additionalDataPreview?.map((element, index) => {
                    return (
                      <Row key={index}>
                        {renderAdditionalDataPreview(
                          element.title,
                          element.isMandatory,
                          element.questionType,
                          element.idFormAdditionalDataQuestion
                        )}
                      </Row>
                    );
                  })}
                </Row>
                <Row>
                  <ContentUpdateButton>
                    <ButtonDone
                      onClick={() =>
                        props.handleUpdateAddionalData(props.additionalData)
                      }
                    >
                      Send Changes
                    </ButtonDone>
                  </ContentUpdateButton>
                </Row>
              </TabPanel>
            </Content>
          </ContentComments>
        </GeneralContainer>
      )}
    </>
  );
};

export default MyCaseDetailComponent;
